import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CustomAlert from "../../components/CustomAlert";
import CustomLoading from "../../components/CustomLoading";
import { paths } from "../../config/router.config";
import wsclients from "../../services/wsclients";
import { getCurrency } from "../../utils/commons";
import OrderProgress from "../orders/OrderProgress";
import ServiceDetailView from "./ServiceDetailView";

export function ServiceDetailController(props) {
    const { serviceChangeSelected, subscriptionSelected, onCloseAll, onClose, open, service } = props;
    const { t } = useTranslation();
    console.log("subscriptionSelected===", subscriptionSelected);

    const [showLoading, onShowLoading] = useState(false);
    const [message, setMessage] = useState({});
    const [selectedDate, setSelectedDate] = useState(1);

    const [activeStep, setActiveStep] = useState(0);
    const [showProgress, setShowProgress] = useState(false);
    const [showButtonClose, setShowButtonClose] = useState(false);
    const [resultProgress, setResultProgress] = useState({
        step: 0,
        status: null,
        code: null,
        message: null
    });
    const [resChangeSRVumatel, setResChangeSRVumatel] = useState(null);
    const [showLoadingProgress, setShowLoadingProgress] = useState(false);

    const dates = [
        {
            label: '1',
            value: '1',
        },
        {
            label: '16',
            value: '16',
        },
        {
            label: '21',
            value: '21',
        },
        {
            label: '26',
            value: '26',
        },
    ]

    const onChangeService = async () => {
        onShowLoading(true)
        setShowProgress(true)
        try {
            await onChangeServiceVumatel();
        } catch (ex) {
            console.log("onChangeService exception===", ex);
        }
        onShowLoading(false);
        setShowButtonClose(true);
    }

    const onChangeServiceVumatel = async () => {
        setShowLoadingProgress(true);
        try {
            let family = service && service.service_to_change_detail && service.service_to_change_detail.family ? service.service_to_change_detail.family : null
            let serviceFrom = subscriptionSelected && subscriptionSelected.service && subscriptionSelected.service.product ? subscriptionSelected.service.product : null
            let showSectionDates = true;
            if(serviceFrom && serviceFrom.family && serviceFrom.family.name === 'Recurring service' && family && family.name === 'Recurring service'){
                showSectionDates = false;
            }
            console.log("serviceFrom AAAAAA===", serviceFrom);

            let body = {
                from_service_id: subscriptionSelected && subscriptionSelected.service && subscriptionSelected.service.id ? subscriptionSelected.service.id : null,
                to_service_id: serviceChangeSelected && serviceChangeSelected.id ? serviceChangeSelected.id : null,
                current_product_id: serviceFrom && serviceFrom.id ? serviceFrom.id : null,
                action: serviceChangeSelected && serviceChangeSelected.change_type ? serviceChangeSelected.change_type : null,
                from_service_code: serviceFrom && serviceFrom.sku ? serviceFrom.sku : null,
                to_service_code: serviceChangeSelected && serviceChangeSelected.sku ? serviceChangeSelected.sku : null,
                is_recuring: family && family.name == 'Non-recurring service' ? false : true,
                recurring_payment_date: showSectionDates && selectedDate ? selectedDate : null,
                payment_redirect_url: window.location.href + paths.change_service_result,
            }
            let result = await wsclients.lab4services.onChangeServiceVumatel(body);
            console.log("onChangeServices result ====", result);
            // result.code = 'OK'//hardcode for test
            if (result.code === 'OK') {
                setShowLoadingProgress(false);
                setResChangeSRVumatel(result.data);
                setActiveStep(1);
                setResultProgress({
                    step: 1,
                    status: 'change_service_vumatel_success',
                    message: t('change_service_vumatel_success')
                });
                await onChangeServiceCRM(result.data);
            } else if (result.code === 'VUMATEL_SERVER_ERROR'){
                setActiveStep(0);
                setShowLoadingProgress(false);
                setResultProgress({
                    step: 0,
                    status: 'ERROR',
                    message:  t('VUMATEL_SERVER_ERROR'),
                    onTryAgain: () => onChangeServiceVumatel(),
                });
                setShowButtonClose(true);
            }
            else {
                setShowLoadingProgress(false);
                let entityError = result.data.error && result.data.error.entity ? JSON.parse(result.data.error.entity) : null;
                setResultProgress({
                    step: 0,
                    status: 'ERROR',
                    message: entityError && entityError.detail && typeof(entityError.detail) === 'string' ? entityError.detail : t('change_service_vumetel_failed'),
                    onTryAgain: () => onChangeServiceVumatel(),
                });
                setShowButtonClose(true);
            }
            // await onChangeServiceCRM();
        }
        catch (ex) {
            console.log("onChangeServices exception===", ex);
        }
    }

    const onChangeServiceCRM = async (resChangeSRVumatel) => {
        setShowLoadingProgress(true)
        try {
            let family = service && service.service_to_change_detail && service.service_to_change_detail.family ? service.service_to_change_detail.family : null
            let price = serviceChangeSelected && serviceChangeSelected.prices && serviceChangeSelected.prices.length > 0 ? serviceChangeSelected.prices[0]: null;
            let serviceFrom = subscriptionSelected && subscriptionSelected.service && subscriptionSelected.service.product ? subscriptionSelected.service.product : null
            let showSectionDates = true;
            if(serviceFrom && serviceFrom.family && serviceFrom.family.name === 'Recurring service' && family && family.name === 'Recurring service'){
                showSectionDates = false;
            }
            let body = {
                action: "CHANGE",
                from_service_id: subscriptionSelected && subscriptionSelected.service && subscriptionSelected.service.id ? subscriptionSelected.service.id : null,
                to_service_id: serviceChangeSelected && serviceChangeSelected.id ? serviceChangeSelected.id : null,
                is_recuring: family && family.name == 'Non-recurring service' ? false : true,
                recurring_payment_date: showSectionDates && selectedDate ? selectedDate : null,
                to_price_terms_id: price && price.id ? price.id : null, 
                subscription_id: subscriptionSelected && subscriptionSelected.subscription && subscriptionSelected.subscription.id? subscriptionSelected.subscription.id : null,
            }
            let result = await wsclients.lab4services.onChangeServiceCRM(body);
            console.log("onChangeServices result ====", result);
            if (result.code === 'OK') {
                setShowLoadingProgress(false)
                setActiveStep(2);
                setResultProgress({
                    step: 2,
                    status: 'change_service_success',
                    message: t('change_service_success')
                });
                setShowButtonClose(true);
                setShowProgress(false);
                await onCloseAll(false);
                await props.onLoad();
                if(resChangeSRVumatel && resChangeSRVumatel.payment_url) window.location.href = resChangeSRVumatel.payment_url
            } else {
                setShowLoadingProgress(false)
                let error = result.data && result.error && result.error.error ? result.error.error : null;
                let mess = t('change_service_failed');
                if(error === 'COM.CRM.EXCEPTIONS.INVALIDSUBSCRIPTIONSERVICELIFECYCLESTATEEXCEPTION'){
                    mess = t('INVALIDSUBSCRIPTIONSERVICELIFECYCLESTATEEXCEPTION')
                }
                setActiveStep(1);
                setResultProgress({
                    step: 1,
                    status: 'ERROR',
                    message: mess,
                    onTryAgain: () => onChangeServiceCRM(),
                });
                setShowButtonClose(true);
            }
        }
        catch (ex) {
            console.log("onChangeServices exception===", ex);
        }
    }

    const onShowMessage = (message) => {
        onShowLoading(false)
        setMessage(message)
    }

    const getSteps = () => {
        return [t('change_service_vumatel'), t('change_service_crm')];
    }

    const onCloseProgress = async () => {
        await onCloseAll(false);
        setShowProgress(false);
        setResultProgress({
            step: 0,
            status: null,
            message: null
        });
    }
    console.log("serviceChangeSelected===", serviceChangeSelected);
    console.log("subscriptionSelected===", subscriptionSelected);
    return (
        <>
            <ServiceDetailView
                open={open}
                service={service}
                dates={dates}
                selectedDate={selectedDate}
                action={serviceChangeSelected && serviceChangeSelected.change_type ? serviceChangeSelected.change_type : null}
                subscriptionSelected={subscriptionSelected}
                serviceChangeSelected={serviceChangeSelected}
                currency={getCurrency()}
                setSelectedDate={setSelectedDate}
                onChangeService={onChangeService}
                onClose={() => onClose()}
            />
            {showProgress &&  <OrderProgress
                open={showProgress}
                t={t}
                orderInfo={resultProgress}
                showLoadingProgress={showLoadingProgress}
                title={t('change_service')}
                sub_title={t('change_service_progress')}
                steps={getSteps()}
                activeStep={activeStep}
                showButtonClose={showButtonClose}
                onClose={() => onCloseProgress()}
            />}
            {message.show && <CustomAlert
                open={message.show}
                message={message.content}
                onClose={() => onShowMessage({})}
                showButtonClose={true}
            />}
            {showLoading && <CustomLoading open={showLoading} />}
        </>
    );
}